import React, { useState, useEffect } from "react";
import { CiMenuBurger } from "react-icons/ci";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/icons/Logo.png";
import searchIcon from "../assets/pic/searchIcon.svg";
import whiteArrow from "../assets/pic/whiteArrow.svg";
import grayArrow from "../assets/pic/grayArrow.svg";
import user from "../assets/pic/avatar.png";

import profilePic from "../assets/pic/profilePic.svg";
import TobreLogo from "../assets/pic/tobreLogo.svg";
const GeneralNav = () => {
  const nav = [
    { id: 1, item: "About Us", link: "/aboutus" },
    { id: 2, item: "Browse Cards", link: "/browse_cards" },
    { id: 5, item: "Pricing", link: "/pricing" },
    { id: 3, item: "Blogs", link: "/blogs" },
  ];
  const [toggleMenu, setToggleMenu] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to control dropdown visibility
  const { pathname } = useLocation();

  const handleToggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev); // Toggle dropdown visibility
  };

  const handleOptionClick = (option) => {
    setIsDropdownOpen(false); // Close dropdown after an option is selected
  };
  const handleToggleMenu = () => {
    setToggleMenu((prev) => !prev);
  };

  useEffect(() => {
    // Prevent scrolling of body content when the modal is open
    if (toggleMenu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [toggleMenu]);
  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      // setNavigateLoader(true);
      setTimeout(() => {
        // window.location.href = "/dashboard/print";
        setLoggedIn(true);
      }, 1000);
    }
  }, []);
  return (
    <div className="relative z-10 items-center justify-between">
      {toggleMenu && (
        <div className="fixed left-1/10 right-1/10 top-0 h-screen bg-white z-50 md:hidden animate-slide-in px-2">
          <img src={TobreLogo} alt="Logo" className="mx-auto mt-5" />
          <div className="flex flex-col items-center justify-center space-y-5 my-auto h-full text-xl">
            {nav.map((item) => (
              <Link
                to={item.link}
                className="flex items-center w-full "
                onClick={handleToggleMenu}
              >
                <button
                  className={`flex items-center justify-center py-1 lg:px-8 px-5 rounded-md w-full`}
                >
                  {item.item}
                </button>
              </Link>
            ))}
            <Link to={"/login"}>
              <button
                onClick={handleToggleMenu}
                className="rounded-md bg-white text-[#2F3649] text-xl md:px-10 px-5 py-1 hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50"
              >
                <span className="flex gap-2">
                  Login <img src={grayArrow} alt="" />
                </span>
              </button>
            </Link>
          </div>
        </div>
      )}
      <nav
        id="general_nav"
        className=" z-10 items-center justify-between max-sm:py-[8px] py-1 bg-white shadow-2xl w-full fixed top-0 left-0"
      >
        {/* <div className="w-full max-w-7xl px-4 sm:px-6 lg:px-8"> */}
        <div className="w-full ml-4 lg:px-14 flex justify-evenly items-center max-md:justify-between max-md:px-2 max-md:ml-0 ">
          {/* Logo */}
          <Link to="/">
            <img
              src={TobreLogo}
              alt="Logo"
              className="w-40 md:w-32 lg:w-32 xl:w-36 max-md:w-24"
            />
          </Link>

          {/* Navigation */}
          <div className="flex items-center gap-x-10">
            <ul className="md:flex hidden items-center sm:space-x-5 space-x-2 text-xl text-slate-700">
              {nav.map((item) => (
                <div key={item.link}>
                  <Link to={item.link}>
                    <li
                      className={`hover:font-semibold hover:text-black ${
                        item.item === "Pricing" ? "text-[#F66]" : ""
                      } ${
                        pathname === "/pricing" && item?.link === "/pricing"
                          ? "font-semibold text-[#F66]"
                          : pathname === item?.link
                          ? "font-semibold text-black"
                          : ""
                      } text-xs sm:text-xs md:text-xs lg:text-lg xl:text-xl`}
                    >
                      {item.item}
                    </li>
                  </Link>
                </div>
              ))}
            </ul>
          </div>

          {/* Login/Profile Section */}
          <div className="flex gap-4 items-center">
            {!loggedIn ? (
              <div>
                <div className="flex items-center gap-x-2">
                  {pathname && pathname !== "/signup" && (
                    <Link to="/signup">
                      <button className="rounded-md bg-[#F66061] text-white md:text-xl text-xs md:px-6 px-3 py-1 hover:bg-primary-dark focus:outline-none">
                        <span className="flex gap-2 items-center">
                          {" "}
                          Sign Up
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#fff"
                            className="max-sm:w-4"
                          >
                            <path d="m216-160-56-56 464-464H360v-80h400v400h-80v-264L216-160Z" />
                          </svg>
                        </span>
                      </button>
                    </Link>
                  )}
                  {pathname && pathname !== "/login" && (
                    <Link
                      to={"/login"}
                      className="rounded-md bg-white  text-primary  text-xs border border-primary md:text-xl md:px-10 px-5 py-1 hover:opacity-90 focus:outline-none"
                    >
                      <button>
                        <span className="flex gap-2 items-center">
                          Login
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#f66061"
                            className="max-sm:w-4"
                          >
                            <path d="m216-160-56-56 464-464H360v-80h400v400h-80v-264L216-160Z" />
                          </svg>
                        </span>
                      </button>
                    </Link>
                  )}

                  <CiMenuBurger
                    className="md:hidden"
                    size={30}
                    onClick={handleToggleMenu}
                  />
                </div>
              </div>
            ) : (
              <div className="relative flex mr-2 gap-4 items-center">
                <img
                  onClick={handleToggleDropdown}
                  src={user}
                  className="cursor-pointer h-[55px] max-md:h-[35px]"
                  alt=""
                />
                <span
                  onClick={handleToggleDropdown}
                  className="cursor-pointer line-clamp-1 max-md:w-20"
                >
                  {localStorage.getItem("username") || "John Dev"}
                </span>
                {isDropdownOpen && (
                  <div className="absolute right-1 top-14 w-40 bg-white shadow-lg rounded-md z-50 max-md:top-9">
                    <ul className="py-1">
                      <Link to="/dashboard/profile">
                        <li
                          className="block px-4 py-2 text-gray-800 hover:bg-gray-200 border-b-1 cursor-pointer"
                          onClick={() => handleOptionClick("Profile")}
                        >
                          Profile
                        </li>
                      </Link>
                      <Link to="/dashboard/print">
                        <li
                          className="block px-4 py-2 text-gray-800 hover:bg-gray-200 border-b-1 cursor-pointer"
                          onClick={() => handleOptionClick("User Portal")}
                        >
                          User Portal
                        </li>
                      </Link>
                      <Link to="/login">
                        <li
                          className="block px-4 py-2 text-gray-800 hover:bg-gray-200 cursor-pointer"
                          onClick={() => {
                            handleOptionClick("Logout");
                            localStorage.clear();
                            setLoggedIn(false);
                          }}
                        >
                          Logout
                        </li>
                      </Link>
                    </ul>
                  </div>
                )}
                <CiMenuBurger
                  className="md:hidden"
                  size={30}
                  onClick={handleToggleMenu}
                />
              </div>
            )}
          </div>

          {toggleMenu && (
            <div
              className="fixed left-0 top-0 h-screen w-screen bg-black opacity-30 z-40 md:hidden"
              onClick={handleToggleMenu}
            />
          )}
        </div>
        {/* </div> */}
      </nav>
    </div>
  );
};

export default GeneralNav;
